export default __webpack_public_path__ + "static/media/selfPick.a296d572.mp3";